import { TRACK_EVENT, TRACK_HEAP_EVENT } from '../constants/actionTypes';

export function trackEvent(noun, verb, params) {
  return {
    type: TRACK_EVENT,
    noun,
    verb,
    params,
  };
}

export function trackHeapEvent(event, additionalDetails = {}) {
  return {
    type: TRACK_HEAP_EVENT,
    event,
    additionalDetails
  };
}
